import { useEffect } from 'react'
import { HugeiconsIcon } from '@hugeicons/react'
import { Moon02Icon, Sun02Icon } from '@hugeicons/core-free-icons'
import { useTheme } from './theme'
import { Button } from '../components/button'

export function ThemeSwitch() {
  const { resolvedTheme, setTheme } = useTheme()
  const dark = resolvedTheme === 'dark'

  useEffect(() => {
    const metaThemeColor = document.querySelector("meta[name='theme-color']")
    metaThemeColor?.setAttribute('content', dark ? '#000000' : '#efeee9')
  }, [dark])

  return (
    <Button
      variant="ghost"
      size="icon"
      title={dark ? 'Light theme' : 'Dark theme'}
      onClick={() => setTheme(dark ? 'light' : 'dark')}
    >
      <HugeiconsIcon
        icon={dark ? Sun02Icon : Moon02Icon}
        strokeWidth={1.8}
        className="size-[18px]"
      />
      <span className="sr-only">Toggle theme</span>
    </Button>
  )
}
